<template>
  <div class="index-info" :class="$route.query.themeStyleVs == 2 ? 'black_theme' : 'white_theme'">
    <div class="header">
      <div class="h_select">
        <van-icon name="arrow-left" @click="$router.go(-1)" />

        <van-field v-model="value" left-icon="search" placeholder="请输入因子名称" />
      </div>
    </div>
    <div class="content">
      <div class="lishi" v-if="qArr.length && frequency === 0">
        <div class="lishi_header">
          <span>历史搜索</span>
          <span @click="clear">清除</span>
        </div>

        <ul class="bufferMemory">
          <li v-for="(item, index) in qArr" :key="index" @click="handleClickHistory(item)">
            {{ item }}
          </li>
        </ul>
      </div>

      <div class="nav-details" v-else>
        <div
          class="li"
          v-for="item in yzList"
          :key="item.ID"
          :style="checkIDExists(checkedYzList, item.ID) ? 'border:1px solid #286DF7;' : ''"
          @click.stop="handleClickCard(item)"
        >
          <h2>
            <span v-if="item.HighLight" v-html="item.HighLight"></span>
            <span v-else>{{ item.Name }}</span>
            <span class="SubClassName" v-if="item.SubClassName"
              >{{ item.ClassName }}-{{ item.SubClassName }}</span
            >
            <span class="cause" v-if="item.BacktestType == 3">不可回测</span>
            <span class="cause" v-if="item.BacktestType == 10">已删除</span>
            <img
              src="../../assets/image/blockImg/vipIcon.png"
              alt=""
              class="vipIcon"
              v-if="item.ExtendType && compareVersions($route.query.version , 9.71)"
            />
          </h2>
          <div class="n-content">
            <!-- <p class="desc">{{ item.Describe }}</p> -->

            <div class="parameter">
              <div class="left">
                <p :class="[judgeColor(item.RiZhangFu)]">
                  {{ toFixedNum(item.RiZhangFu * 100, 2, '%') }}
                </p>
                <p class="zhi">{{ item.XinHaoShuLiang || 0 }}只</p>
              </div>
              <div
                v-if="
                  (item.BacktestType != 3 && item.BacktestType != 10) ||
                  $route.query.source === 'dtzh'
                "
              >
                <span
                  v-if="!checkIDExists(checkedYzList, item.ID)"
                  @click.stop="addYz(item)"
                  class="handleClickYz"
                >
                  <img src="@/assets/image/tj.png" alt="" />
                </span>
                <span v-else @click.stop="delYz(item)" class="handleClickYz">
                  <img src="@/assets/image/sc.png" alt="" />
                </span>
              </div>
            </div>
          </div>
        </div>

        <p class="selNull" v-if="!yzList.length">{{ selHint }}</p>
      </div>
    </div>

    <div class="bottom-pd">
      <div class="bottom-btn">
        <div class="left" @click="showActionFunc()">
          选中的因子 <span class="num">{{ checkedYzNum }}</span>
        </div>

        <button
          v-if="$route.query.source === 'dtzh'"
          class="r-btn"
          :disabled="!checkedYzNum"
          @click="goDtzhPreview"
          :style="checkedYzNum ? 'color:#fff;background: #286DF7;' : ''"
        >
          查看结果<span v-if="!isResultLoading"
            >({{ resultNum }}{{ defaultIndex == 1 ? '只ETF' : '只股票' }})
          </span>
          <span v-else>
            <van-loading
              type="spinner"
              :color="checkedYzNum > 0 ? '#fff' : '#858586'"
              size="16"
              ><span :color="checkedYzNum > 0 ? '#fff' : '#858586'"
                >加载中</span
              ></van-loading
            >
          </span>
        </button>

        <button
          v-else
          class="r-btn"
          :disabled="!checkedYzNum"
          @click="goArguments"
          :style="checkedYzNum > 0 ? 'color:#fff;background: #286DF7;' : ''"
        >
          选择条件
        </button>
      </div>
    </div>

    <!-- 新版交并集 -->
     <van-popup v-model="showActionSheet" position="bottom"  @closed="checkSonFactorList" :style="{ height: 'auto' }" >
      <FactorSetOperatorModal  @close="showActionSheet = false" > </FactorSetOperatorModal>
     </van-popup>

    <!-- <van-action-sheet v-model="showActionSheet" title="">
      <div class="actionSheet-title">
        <p class="name">
          <van-icon name="arrow-left" @click="showActionSheet = false" />已选因子组合池
        </p>
        <p class="handle-clear" @click="handleClear">清空组合池</p>
      </div>
      <ul class="actionSheet-content" v-if="checkedYzList.length">
        <li v-for="(item, index) in checkedYzList" :key="index">
          <div class="a-left">
            {{ item.FactorName }}

            <p class="subClassName">{{ item.XiFenZhongLei || item.SubClassName }}</p>
          </div>

          <div class="a-right">
            <p :class="[judgeColor(item.RiZhangFu)]">
              {{ toFixedNum(item.RiZhangFu * 100, 2, '%') }}
            </p>
            <p class="zhi">{{ item.XinHaoShuLiang || 0 }}只</p>

            <img
              src="@/assets/image/tj.png"
              alt=""
              @click.stop="addYz(item)"
              v-if="!checkIDExists(checkedYzList, item.ID)"
            />
            <img src="@/assets/image/sc.png" alt="" @click.stop="delYz(item)" v-else />
          </div>
        </li>
      </ul>

      <p v-else class="null">暂无添加的因子</p>
    </van-action-sheet> -->

    <!-- 点击卡片显示的信息 -->
    <div class="card">
      <van-popup v-model="showCard" round position="bottom" style="min-height: 30%" overlay
  overlay-class="select-yz-overlay"  >
        <div class="popup_body">
          <p class="title">{{ cardMsg.Name }}</p>

          <div class="background">
            <van-row v-if="cardMsg.yzType != 1 && cardMsg.yzType != 2 && cardMsg.yzType != 3">
              <van-col span="6">
                <span class="label">今日涨幅:</span>
              </van-col>
              <van-col span="6" class="zf">
                <p :class="[judgeColor(cardMsg.RiZhangFu)]">
                  {{ toFixedNum(cardMsg.RiZhangFu * 100, 2, '%') }}
                </p>
              </van-col>

              <van-col span="6">
                <span class="label">今日信号数:</span>
              </van-col>
              <van-col span="6">
                <p class="zhi">{{ cardMsg.XinHaoShuLiang || 0 }}只</p>
              </van-col>
            </van-row>

            <van-row>
              <van-col span="6">
                <span class="label">所属分类:</span>
              </van-col>
              <van-col span="18">
                <span class="XiFenZhongLei"
                  >{{ cardMsg.ClassName }}-{{ cardMsg.SubClassName }}</span
                >
              </van-col>
            </van-row>

            <van-row>
              <van-col span="6">
                <span class="label">因子描述:</span>
              </van-col>
              <van-col span="18">
                <span class="Desc">{{ cardMsg.Describe }}</span>
              </van-col>
            </van-row>
          </div>

          <div class="btn">
            <button class="cancel" @click="showCard = false">取消</button>
            <van-button
              class="add"
              @click.stop="addYz(cardMsg), (showCard = false)"
              v-if="!checkIDExists(checkedYzList, cardMsg.ID)"
              :disabled="
                (cardMsg.BacktestType == 3 || cardMsg.BacktestType == 10) &&
                $route.query.source != 'dtzh'
              "
            >
              添加到因子组合池
            </van-button>

            <button class="add" @click.stop="delYz(cardMsg), (showCard = false)" v-else>
              移出因子组合池
            </button>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import mixin from '@/mixins/index.js';
import { judgeColor, toFixedNum, removeValueFromArray, strToHexCharCode,compareVersions,factorCombinationToCode } from '@/utils/format';
import { getFactorHq, searchFactors, getDayStockPool } from '@/api/create.js';
import { Base64 } from 'js-base64';

export default {
  name: 'SelectYz',
  mixins: [mixin],
  data() {
    return {
      defaultIndex: 0,
      ProductType: null,
      value: '',
      activeKey: 0,
      loading: false,
      finished: false,
      navList: [],
      yzList: [],
      page: 1,
      ClassId: null,
      inishedText: '加载中...',
      checkedYzList: [],
      showActionSheet: false,
      qArr: [],
      frequency: 0,
      selHint: '请输入关键词进行搜索',
      resultNum: 0,
      isResultLoading: false,
      showCard: false,
      cardMsg: {},
      isVip: false,
      // 选中的因子数量
      checkedYzNum: 0,
    };
  },
  components: {},
  filters: {},
  created() {
    this.debouncedSearchFactorsFun = this.debounce(this.searchFactorsFun, 500);
  },

  //计算属性
  computed: {
    selHistory: function () {
      return this.$store.state.selHistory;
    },
    groupYzList() {
      return this.$store.state.groupYzList;
    },
    checkedYzType() {
      return this.$store.state.checkedYzType;
    }
  },
  async mounted() {
    this.qArr = this.selHistory || [];

    // if (this.Obj.yzIds) {
    //   this.getFactorHqFun(this.Obj.yzIds);
    // } else {
    // this.checkedYzList = this.$store.state.checkedYzList || [];
    // }

    this.checkedYzList = this.$store.state.checkedYzList || [];
    if (this.$route.query.dtzhCheckedYzList && this.$store.state.checkedYzList.length) {
      this.ProductType = this.$store.state.checkedYzList[0].ProductType;
    }

    // 解析 groupYzList（因子交并集分组数据）
    if (this.$route.query.groupYzList) {
      let groupList = JSON.parse(this.decodeUrlParameter(this.$route.query.groupYzList));
      console.log('selectYz groupYzList', groupList);
      this.$store.commit('setGroupYzList', groupList);
    }

    // 解析 checkedYzType（交并集类型：jj=交集，bj=并集）
    if (this.$route.query.checkedYzType) {
      console.log('selectYz checkedYzType', this.$route.query.checkedYzType);
      this.$store.commit('setCheckedYzType', this.$route.query.checkedYzType);
    }

    // if (window.DzhAppJs) {
    //   DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc('', 'true', 'interceptOnKeyDown'); //安卓里面禁用返回功能
    // }

    if (this.$route.query.yzType == 'ETF' || this.ProductType == 'ETF') {
      this.defaultIndex = 1;
    } else {
      this.defaultIndex = 0;
    }
    this.isDtzhSelectStock();
  },
  watch: {
    '$store.state.isVip': {
      handler(newValue) {
        this.isVip = newValue;
      },
      immediate: true // 立即执行一次
    },
    value(newVal) {
      this.debouncedSearchFactorsFun(newVal);
    },

    checkedYzList() {
      this.$store.commit('setCheckedYzList', this.checkedYzList); // 提交 mutation 来更新全局状态

      this.checkedYzNumStatic();

    //   //如果是动态组合  就调用当日股池接口
      if (this.$route.query.source === 'dtzh') {
        this.isDtzhSelectStock();
        // let yzIds = [];
        // this.checkedYzList.forEach((i) => {
        //   if (i.ID) {
        //     yzIds.push(i.ID + '&');
        //   }
        // });

        // let hexyzIds = ':' + strToHexCharCode(':&' + yzIds.join(''));
        // this.getDayStockPoolFun(hexyzIds);
      }
    },
    groupYzList: {
      handler(newVal) {
        console.log('父组件监听到变化了', newVal);
        // 如果你需要把 Vuex 的数据同步回组件内的 unionGroups
        // 只有当 isInternalSync 为 false 时才同步，避免循环更新
        if (!this.isInternalSync) {
           this.unionGroups = JSON.parse(JSON.stringify(newVal));
        }
        this.checkedYzNumStatic();
      },
      deep: true
    }
  },
  methods: {
    judgeColor,
    toFixedNum,
    compareVersions,

    //将URL参数中的 * 替换为 +，- 替换为 /，. 替换为 =，然后进行Base64解码
    decodeUrlParameter: function (encodedUrl) {
      var replacedString = encodedUrl
        .replace(/\*/g, '+')
        .replace(/-/g, '/')
        .replace(/\./g, '=');
      var decodedString = Base64.decode(replacedString);
      return decodedString;
    },
    //将数据进行Base64编码，+ 替换为 *，/ 替换为 -，= 替换为 .
    encodeUrlParameter: function (data) {
      var jsonString = JSON.stringify(data);
      var encodedString = Base64.encode(jsonString);
      var replacedString = encodedString
        .replace(/\+/g, '*')
        .replace(/\//g, '-')
        .replace(/=/g, '.');
      return replacedString;
    },

    //当日股池
    getDayStockPoolFun: function (yzIds) {
      let _this = this;
      console.log('yzIdsyzIdsyzIds',yzIds);
      _this.isResultLoading = true;
      var params = {
        factorIDs: yzIds, //string 因子id组，逗号分隔,如：单个因子时factorIDs=Id1，多因子 factorIDs=Id1,Id2,Id3,Id4
        start: 1,
        count: 1,
        desc: true, //排序方式, 可选项包括:false(升序),true(降序)
        field: 'ZhangFu' //排序字段,*表示必填,可选项见表后说明,排序字段只能从field可选项中任选其一
      };
      getDayStockPool(params)
        .then((res) => {
          _this.isResultLoading = false;
          _this.resultNum = res.data.ObjCount || 0;
        })
        .catch((err) => {
          _this.isResultLoading = false;
          _this.$toast(err);
        });
    },

    //节流
    debounce(func, delay) {
      let timeoutId;
      return function (...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          func.apply(this, args);
        }, delay);
      };
    },
    //搜索因子
    searchFactorsFun: function (q) {
      this.frequency++;
      if (q === '') return false;

      this.$toast.loading({
        message: '加载中...',
        overlay: true,
        duration: 0
      });

      this.selHint = '加载中...';

      var params = {
        q: this.value,
        type_info: this.$route.query.yzType == 'ETF' ? 2 : 1 //1- A 股 2-ETF
      };

      searchFactors(params)
        .then((res) => {
          this.$toast.clear();
          // 使用map函数添加yzType字段并赋值为0
          this.yzList = res.data.map(function (item) {
            item.yzType = 0;
            return item;
          });

          if (res.data.length) {
            if (this.qArr.includes(q)) {
              // 如果数据已存在于数组中，则将其移动到第一位
              const index = this.qArr.indexOf(q);
              this.qArr.splice(index, 1); // 从原位置删除
            }

            if (this.qArr.length >= 10) {
              this.qArr.pop(); // 删除最后一条数据
            }

            this.qArr.unshift(q); // 将新数据放在数组的第一位
            this.$store.commit('setSelHistory', this.qArr);
          } else {
            this.selHint = '暂无相关因子，换一个关键词试试';
          }
        })
        .catch((err) => {
          this.selHint = 'err';
          this.$toast(err);
        });
    },

    //清空本地缓存
    clear: function () {
      this.$store.commit('resetSelHistory');
      this.qArr = [];
    },

    //点击历史数据
    handleClickHistory: function (q) {
      this.value = q;
    },
    //行情
    getFactorHqFun: function (yzIds) {
      var params = {
        type: 'yz',
        factorID: yzIds,
        field: 'HuoYueDu,Desc'
      };
      getFactorHq(params)
        .then((res) => {
          this.checkedYzList = res.data;
          this.$store.commit('setCheckedYzList', res.data);
        })
        .catch((err) => {
          this.$toast(err);
        });
    },

    //判断当前因子是否选中
    checkIDExists: function (dataList, id) {
      for (let i = 0; i < dataList.length; i++) {
        if (dataList[i].ID == id) {
          return true;
        }
      }

      // 检查 groupYzList (并集组合)
      if (this.groupYzList && this.groupYzList.length) {
        for (let i = 0; i < this.groupYzList.length; i++) {
          let group = this.groupYzList[i];
          if (Array.isArray(group)) {
            for (let j = 0; j < group.length; j++) {
              // 兼容 ID
              if (group[j].ID == id) {
                return true;
              }
            }
          }
        }
      }

      return false;
    },

    //点击卡片显示描述等信息
    handleClickCard: function (item) {
      this.showCard = true;
      this.cardMsg = item;
    },

    //点击添加因子 +
    addYz: function (item) {
      if(this.isVip == false && compareVersions(this.$route.query.version , 9.92) ) {
        let appJson = {
          DialogType: "basic",
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorTYPerDialog',
          JSON.stringify(appJson),
          ''
        );
        return false;
      } else if (this.isVip == false && compareVersions(this.$route.query.version , 9.71) && item.ExtendType) {
        const appJsonTypeData = {
          channel: 'yinzi',
          dzhadid: '0807'
        };

        // 如果不是VIP用户,弹出VIP提示
        // 调用客户端js 弹窗
        window.DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorNoVipPerDialog',
          JSON.stringify(appJsonTypeData),
          ''
        );

        return false;
      }

      if (this.checkedYzNum >= 10) {
        this.$toast('最多添加10个因子');

        return false;
      }

      //这一步吧博士接口的Name修改为FactorName  和浩哥的接口做统一
      var modifiedData = {
        ...item,
        FactorName: item.Name
      };
      delete modifiedData.Name;
      this.checkedYzList.push(modifiedData);
    },
    //删除选中的因子 -
    delYz: function (item) {
      if (item.yzType == 0) {
        removeValueFromArray(this.checkedYzList, item.ID);
      } else {
        removeValueFromArray(this.checkedYzList, item.Info);
      }
    },
    //清空选中的因子
    handleClear: function () {
      this.checkedYzList = [];
      this.showActionSheet = false;
    },

    //跳转选择参数页面
    goArguments: function () {
    //   this.$store.commit('setCheckedYzList', this.checkedYzList); // 提交 mutation 来更新全局状态

      // this.$store.commit('resetObj');

      //   校验组合中是否大于一个
        if (!this.checkGroupLength()) {
            return false;
        }

      if (
        this.$route.query.source === 'dyzcl' ||
        this.$route.query.source === 'appDyzHc' ||
        this.$route.query.source === 'appCl'
      ) {
        this.$router.push({
          path: '/dyzArguments',
          name: 'DyzArguments',
          query: {
            token: this.$route.query.token || '',
            themeStyleVs: this.$route.query.themeStyleVs || 0,
            version: this.$route.query.version || '',
            source: this.$route.query.source,
            yzType: this.$route.query.yzType || '',
            mySource: this.$route.query.mySource || '',
            createType: this.$route.query.createType || ''
          }
        });
      } else if (this.$route.query.source === 'lhcl' || this.$route.query.source === 'appLhHc') {
        const query = {
            token: this.$route.query.token || '',
            type: this.getUrlQuery('type') ? this.getUrlQuery('type') : '',
            themeStyleVs: this.$route.query.themeStyleVs || 0,
            version: this.$route.query.version || '',
            source: this.$route.query.source,
            yzType: this.$route.query.yzType || '',
            mySource: this.$route.query.mySource || '',
            createType: this.$route.query.createType || '',
            zxgType: this.$route.query.zxgType || 0,
            mark: this.$route.query.mark || '',
          }

        if(this.$route.query.zdyType == '1') {
          query.zdyType = 1;
          this.$router.push({
            path: '/arguments',
            name: 'arguments',
            query: query
          });
        } else {
          this.$router.push({
            path: '/lhArguments',
            name: 'LhArguments',
            query: query
          });
        }

        // this.$router.push({
        //   path: '/lhArguments',
        //   name: 'LhArguments',
        //   query: query
        // });
      }
    },

    //跳转查看今日股票列表页
    goDtzhPreview: function () {
      let query;
      /**
       * ! 这个地方增加获取ETF的判断 (王文浩)
       */


       //   校验组合中是否大于一个
        if (!this.checkGroupLength()) {
            return false;
        }

      if (this.$route.query.dtzhCheckedYzList) {
        query = {
          token: this.$route.query.token || '',
          mySource: this.$route.query.mySource,
          source: this.$route.query.source,
          themeStyleVs: this.$route.query.themeStyleVs || 0,
          version: this.$route.query.version || '',
          dtzhCheckedYzList: this.$route.query.dtzhCheckedYzList || '',
          groupYzList: this.groupYzList.length ? this.encodeUrlParameter(this.groupYzList) : '',
          checkedYzType: this.checkedYzType || '',
          id: this.$route.query.id || '',
          name: this.$route.query.name || '',
          yzType: this.$route.query.yzType || ''
        };
      } else {
        query = {
          token: this.$route.query.token || '',
          mySource: this.$route.query.mySource,
          source: this.$route.query.source,
          themeStyleVs: this.$route.query.themeStyleVs || 0,
          version: this.$route.query.version || '',
          yzType: this.$route.query.yzType || ''
        };
      }

      this.$router.push({
        path: '/dtzh-preview',
        name: 'Dtzh-preview',
        query: query
      });
    },
    // 计算选中的因子
    checkedYzNumStatic(){

      console.log('groupYzList',this.groupYzList);

      const allIDs = this.groupYzList.flat();
      this.checkedYzNum = this.checkedYzList.length + allIDs.length;
    },
    // 点击打开底部弹窗
    showActionFunc(){
      var _this = this;
      console.log('222');

      if(_this.checkedYzNum > 0) {
        _this.showActionSheet = true
      }
    },
    checkSonFactorList() {
            // 使用 filter 过滤掉空数组，并更新 store
            const newList = this.groupYzList.filter((item) => item && item.length > 0);

            if (newList.length !== this.groupYzList.length) {
                this.$store.commit('setGroupYzList', newList);
            }

            this.isDtzhSelectStock();
        },
        // 调用动态组合选股
        isDtzhSelectStock() {
            var _this = this;
            //如果是动态组合  就调用当日股池接口
            if (this.$route.query.source === 'dtzh' || this.$route.query.dtzhCheckedYzList) {
                console.log('_this.checkedYzList', _this.checkedYzList);
                console.log('_this.groupYzList', _this.groupYzList);
                console.log('_this.checkedYzType', _this.checkedYzType);

                // 组合因子交并集
                var hexYzObj = factorCombinationToCode(
                    _this.checkedYzList,
                    _this.groupYzList,
                    _this.checkedYzType
                );
                console.log('hexYzObj', hexYzObj);

                _this.getDayStockPoolFun(hexYzObj.hexyzIds);
            }
        },
        // 校验交集并集组合中只有一个因子的情况
        checkGroupLength() {
            var _this = this;
            for (let i = 0; i < _this.groupYzList.length; i++) {
                const item = _this.groupYzList[i];
                console.log('item', item);
                if (item.length <= 1) {
                    _this.$toast('组合中的因子需要大于1个');
                    return false;
                }
            }
            return true;
        }
  }
};
</script>
<style lang="less" scoped>

.popup_body {
  padding: 16px;
  .title {
    color: #222;
    font-size: 16px;
    font-weight: 500;
  }
  .background {
    border-radius: 8px;
    background: #f7f7fc;
    padding: 16px;
    margin-top: 19px;
    line-height: 25px;
    .label {
      color: #999;
      font-size: 14px;
    }
    .Desc {
      color: #555;
    }
  }
  .btn {
    padding: 24px 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .cancel,
    .add {
      font-size: 16px;
      border-radius: 20px;
      height: 41px;
    }
    .cancel {
      width: 120px;
      border: 1px solid #286df7;
      background: #fff;
      color: #286df7;
    }
    .add {
      width: 215px;
      border: 1px solid #286df7;
      background: #286df7;
      color: #fff;
    }
  }
}
.index-info {
  position: relative;
  background: #f0f7ff;
  min-height: 100vh;
  .header {
    padding: 44px 40px 12px 6px;
    background: #fff;
    position: sticky;
    top: 0;
    width: 100%;
    .h_select {
      display: flex;
      align-items: center;
      .van-icon-arrow-left {
        font-size: 20px;
        margin-right: 10px;
        color: #333;
      }
      .van-cell {
        padding: 0;
        border-radius: 20px;
        height: 32px;
        line-height: 32px;
        padding: 0 12px;
        background: #f7f7fc;
      }
    }
  }
  .content {
    .lishi {
      padding: 12px;
      .lishi_header {
        font-size: 14px;
        color: #999;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .bufferMemory {
        display: flex;
        flex-wrap: wrap;
        li {
          height: 25px;
          line-height: 25px;
          border-radius: 2px;
          padding: 0 8px;
          background: rgba(0, 0, 0, 0.04);
          margin-right: 8px;
          margin-top: 8px;
        }
      }
    }
    .nav-details {
      padding: 0 10px 100px;
      ::v-deep {
        .li {
          background: #fff;
          border-radius: 8px;
          padding: 10px 8px;
          margin: 10px 0;
          .vipIcon {
            width: 20px;
            height: 13px;
            margin-left: 4px;
          }
          h2 {
            font-size: 16px;
            color: rgba(0, 0, 0, 0.9);
            display: flex;
            align-items: center;
            b {
              color: #3b85fe;
              font-weight: normal;
            }
            span {
              font-weight: normal;
            }
            .SubClassName {
              color: rgba(40, 109, 247, 1);
              font-size: 12px;
              background: rgba(40, 109, 247, 0.1);
              padding: 2px 10px;
              border-radius: 4px;
              margin-left: 5px;
            }
            .cause {
              font-size: 12px;
              border: 1px solid #999;
              color: #999;
              border-radius: 4px;
              padding: 1px 3px;
              margin-left: 4px;
            }
          }
          .n-content {
            border-radius: 4px;
            padding: 8px;
            background: rgba(0, 0, 0, 0.02);
            margin-top: 8px;
            .desc {
              font-size: 12px;
              color: #555;
            }
            .parameter {
              display: flex;
              align-items: center;
              justify-content: space-between;
              .left {
                display: flex;
                align-items: center;
                p {
                  font-size: 16px;
                  margin-right: 16px;
                }
              }
              .handleClickYz {
                padding: 10px;
                display: block;
                img {
                  width: 17px;
                  height: 16px;
                  flex-shrink: 0;
                }
              }
            }
          }
        }
      }
      .selNull {
        text-align: center;
        padding-top: 104px;
        font-size: 14px;
        color: #999999;
      }
    }
  }
  .bottom-pd {
    position: fixed;
    bottom: 34px;
    left: 0px;
    width: 100%;
    padding: 0 16px;
    z-index: 99;
    .bottom-btn {
      border-radius: 20px;
      background: #0e0c0d;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      z-index: 9;

      .left {
        font-size: 16px;
        color: #fff;
        display: flex;
        align-items: center;
        padding: 8px 0 8px 23px;
        .num {
          font-size: 14px;
          width: 24px;
          height: 24px;
          border-radius: 8px;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          background: #3b85fe;
          margin-left: 8px;
        }
      }
      .r-btn {
        display: flex;
        align-items: center;
        font-size: 16px;
        color: #858586;
        padding: 0px 16px;
        background: #1b3b82;
        border-radius: 0 20px 20px 0;
        height: 40px;
      }
    }
  }
}
::v-deep {
  .van-action-sheet__content {
    padding: 0 16px 120px 16px;
  }
  .actionSheet-content {
    border-radius: 8px;
    padding: 8px;
    background: #f7f7fc;
    li {
      margin: 6px 0;
      border: 1px solid #e7e7e7;
      padding: 3.5px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #fff;
      .a-left {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.9);
        padding-left: 9.5px;
        .XiFenZhongLei,
        .subClassName {
          font-size: 10px;
          color: #999;
        }
      }
      .a-right {
        border-radius: 4px;
        padding: 8px 12px;
        background: rgba(0, 0, 0, 0.02);
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 50%;
        font-size: 12px;
        color: #555;
        img {
          width: 17px;
          height: 16px;
          flex-shrink: 0;
        }
      }
    }
  }
  .null {
    font-size: 14px;
    text-align: center;
    color: #ccc;
    height: 40px;
    line-height: 40px;
  }
  .actionSheet-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: sticky;
    top: 0;
    background: #fff;
    .name {
      padding: 13px 0;
      font-size: 14px;
      color: #999;
    }
    .handle-clear {
      font-size: 14px;
      color: #286df7;
    }
  }
}
</style>

<!-- 黑色主题 -->
<style lang="less" scoped>
.black_theme {
  background: #181a23;
  .popup_body {
    padding: 16px;
    .title {
      color: #222;
      font-size: 16px;
      font-weight: 500;
    }
    .background {
      background: #2b2d3d;
    }
    .btn {
      .cancel {
        background: #1e1f2d;
        color: #286df7;
      }
      .add {
        color: #e4e9fe;
      }
      ::v-deep {
        .van-button--disabled {
          color: #858586 !important;
          background: #1b3b82 !important;
          border: none !important;
        }
      }
    }
    .title,
    .zhi,
    .zf,
    .XiFenZhongLei,
    .Desc {
      color: #e4e9fe;
    }
  }
  .cause {
    border: 1px solid #6b7687 !important;
    color: #6b7687 !important;
  }
  .header {
    background: #181a23;
    ::v-deep {
      .h_select {
        .van-icon-arrow-left {
          color: #e4e9fe;
        }
        .van-cell {
          background: #1d202d;
        }
        .van-icon-search,
        .van-field__control {
          color: #6b7687;
        }
      }
    }
  }
  .lishi {
    .lishi_header {
      span {
        color: #6b7687;
      }
    }
    .bufferMemory {
      li {
        color: #aab9d1;
      }
    }
  }
  .content {
    .nav-details {
      .li {
        background: #2e3548;
        h2 {
          color: #e4e9fe;
        }
        .n-content {
          background: #1d202d;
          .desc {
            color: #aab9d1;
          }
          .left {
            p,
            .zhi {
              color: #aab9d1;
            }
          }
        }
      }
    }
  }
  ::v-deep {
    .van-popup,
    .actionSheet-title {
      background: rgb(30, 31, 45);
    }
    .actionSheet-title {
      .name {
        color: #aab9d1;
      }
    }
  }
  .actionSheet-content {
    background: #2e3548;
    li {
      background: rgb(30, 31, 45);
      border: 1px solid rgb(30, 31, 45);
      color: #e4e9fe;
      .a-left,
      .a-right .zhi {
        color: #e4e9fe;
      }
      .subClassName {
        color: #6b7687;
      }
    }
  }
}
</style>
